import Icon from "../../UI/Icon/Icon";
import userImg from "../../../assets/img/user.jpg";
import classes from "./Header.module.scss";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/authContext";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { fetchLocations, setSelectedLocation } from "../../../redux/locations";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LanguageSwitcher from "./LanguageSwitcher/LanguageSwitcher";

const Header = () => {
  const { t, i18n } = useTranslation();
  const { locations, selectedLocation, error } = useSelector(
    (state) => state.location
  );
  const dispatch = useDispatch();
  const { token, logout, loggedInUser } = useContext(AuthContext);
  const [showActionMenu, setShowActionMenu] = useState(false);
  const [time, setTime] = useState(new Date().toISOString());

  const toggleActionMenu = () => {
    setShowActionMenu((oldState) => !oldState);
  };

  const handleLanguage = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  const handleLocationChange = (e) => {
    const locationId = e.target.value;
    let locationIndex = locations.findIndex((location) => {
      return location.id === +locationId;
    });
    localStorage.setItem("location", JSON.stringify(locations[locationIndex]));
    dispatch(setSelectedLocation(locationId));
  };

  useEffect(() => {
    let interval = setInterval(() => {
      setTime(new Date().toISOString());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (token) {
      dispatch(fetchLocations(token));
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (error) {
      toast.error("Login Expired. Please login again!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }, [error]);

  useEffect(() => {
    if (!selectedLocation && locations.length) {
      const location = JSON.parse(localStorage.getItem("location"));
      if (!location) {
        localStorage.setItem("location", JSON.stringify(locations[0]));
        return dispatch(setSelectedLocation(locations[0].id));
      }
      return dispatch(setSelectedLocation(location.id));
    }
  }, [locations, selectedLocation, dispatch]);

  return (
    <header className={classes.Header}>
      <ToastContainer />
      <h1 className={classes.Heading1}>{t("ORDERS")}</h1>
      <div className={classes.SearchInput}>
        <Icon name="magnifier" />
        <input type="text" placeholder={t("SEARCH_PLACEHOLDER")} />
      </div>
      <div className={classes.TimeAndStatus}>
        <div className={classes.TimeBox}>
          <Icon name="clock" />
          <p className={classes.Time}>
            {moment(time).format("HH:mm, d MMMM YYYY")}
          </p>
        </div>
      </div>
      {/* Location Switcher */}
      {locations.length > 0 && selectedLocation && (
        <select
          style={{ margin: "0 1rem" }}
          onChange={handleLocationChange}
          defaultValue={selectedLocation}
        >
          {locations.map((location, index) => {
            return (
              <option key={location.name + index} value={location.id}>
                {location.name}
              </option>
            );
          })}
        </select>
      )}
      {/* Location Switcher End */}
      {/* Language Switcher */}
      {/* <select
        style={{ margin: "0 1rem" }}
        onChange={handleLanguage}
        defaultValue={i18n.language}
      >
        <option value="en">English</option>
        <option value="ar">العربية</option>
      </select> */}
      {/* <div className={classes.LanguageSwitcher}>
        <button>
          <Icon name="flag-us" width={1.6} height={1.2} />
          <span>ENG</span>
          <Icon name="chevron-down" width={1.6} height={1.6} />
        </button>
        <ul>
          <li>
            <Icon name="flag-us" width={1.6} height={1.2} />
            <span>ENG</span>
          </li>
        </ul>
      </div> */}
      <LanguageSwitcher />
      {/* Language Switcher End */}
      <div className={classes.Notifications}>
        <button className={classes.NotificationsToggler}>
          <Icon name="bell" width={2.4} height={2.4} />
          <span>3</span>
        </button>
      </div>
      <div className={classes.UserBox} onClick={toggleActionMenu}>
        <p className={classes.UserName}>{loggedInUser.name}</p>
        <p className={classes.UserRole}>{t("ADMIN")}</p>
        <div className={classes.UserImage}>
          <img src={userImg} alt="User" />
        </div>
        <Icon name="chevron" />
        {showActionMenu && (
          <div className={classes.UserMenu}>
            <ul>
              <li>
                <button>{t("MY_PROFILE")}</button>
              </li>
              <li>
                <button onClick={logout}>{t("LOGOUT")}</button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
